import { Injectable, OnInit, Injector } from '@angular/core';
import {ParserService } from '../ws/ws.service';
import {environment} from '../../../../environments/environment';
import {IHbParser} from './hb-parser';
import {IHbManager} from './hb-manager';
import {WsService2} from '../ws/ws.service';
@Injectable()
export class HbParserService extends ParserService implements IHbParser{
constructor(ws: WsService2){
    console.log("Creatng hb parser service")
       super(ws);
    }
    setHbManager(r:IHbManager){
        console.log("Setting hb manager ");
        this.hbManager = r;
    }
    hbManager: IHbManager
   parseMessage(m){
       switch (m.cmd){
           case "hb": this.onHb(); break;
           
       }
   }
    onHb(){
        this.hbManager.onHb();
    }
 
  sendHb(){
      this.send("hb");
  }
  onConnected(){
      this.hbManager.onConnected();
  }
  onDisconnected(){
      this.hbManager.onDisconnected();
  }
  close(){
      
      //this.send("bye");
      this.ws.close();
  }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/hb/hb-parser.service.ts